import { render, staticRenderFns } from "./popups-login.vue?vue&type=template&id=29bfbc4c&scoped=true"
import script from "./popups-login.vue?vue&type=script&lang=js"
export * from "./popups-login.vue?vue&type=script&lang=js"
import style0 from "./popups-login.vue?vue&type=style&index=0&id=29bfbc4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfbc4c",
  null
  
)

export default component.exports